import getApi from '../../api'
import { StatsConversationDetail } from '../../model/StatsAssistant'

export const getConversation = (ulid: string) =>
  getApi().get<StatsConversationDetail>(`/stats_assistant/conversations/${ulid}`)
